import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { NatureService } from './../../../../services/administration/nature.service';

@Component({
  selector: 'app-nature',
  templateUrl: './nature.component.html',
  styleUrls: ['./nature.component.scss']
})
export class NatureComponent implements OnInit {

  gridConfig: GridOptions;
  activeAdd = false;
  dateSelected: any;

  constructor( private natureService: NatureService) {
    this.gridConfig = <GridOptions>{};
    this.gridConfig.columnDefs = [
      { headerName: 'Description', field: 'description', colId: 'description', width: 300 }
    ];
  }

  ngOnInit() {
    this.getAllData();
  }

  getAllData() {
    this.natureService.getAll().subscribe(response => {
      this.gridConfig.api.setRowData(response);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/administration/reservations/nature/nature.component.ts